import { css } from '@emotion/react'
import { theme } from '@app/styles/theme'

export const logoContainer = () => css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  cursor: pointer;
  height: 70px;
  padding: 20px;
`

export const sidebarFullLogo = css`
  opacity: 1;
  transition:
    opacity 0.1s,
    transform 0.2s;
  transform: translateX(0px);
  height: 55px;
  width: auto;
  padding: 5px;
  margin: 0 ${theme.spacing(2)}px;
`

export const sidebarSimpleLogo = css`
  object-fit: contain;
  opacity: 1;
  transition:
    opacity 0.1s,
    transform 0.2s;
  transform: translateX(0px);
`
